import React, {useEffect, useState} from 'react';
import TextDisplay from '../../Forms/TextDisplay/TextDisplay';
import SingleLineField from '../../Forms/SingleLineField/SingleLineField';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import { Icon, CompoundButton } from '@fluentui/react';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import Post from '../../../Data/Post';
import './PrintPublish.css';
import { WriteAndDownloadReport } from '../../Reports/ReportWriter';
import PostEvent from '../../../Data/PostEvents';
import SuccessMessage from '../../General/SuccessMessage/SuccessMessage';
import CurrentDate from '../../../Utils/Local/CurrentDate';
import { FormatReportData } from '../../Reports/Functions/FormatReportData';

const PrintPublish = (props) => {

    const printIcon = <Icon iconName="Print" />;
    const publishIcon = <Icon iconName="PublisherLogo" />;

    const nameConfig = { Id: "PublishName", Type: 'singleline', Label: TranslateTag("@GenNam@", props.language) };

    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [successStatus, setSuccessStatus] = useState({visible: false, message: ''});
    const [reportConfig, setReportConfig] = useState();
    const [reportData, setReportData] = useState([]);
    const [originalReportData, setOriginalReportData] = useState([]);    
    const [reportName, setReportName] = useState();
    const [printSelector, setPrintSelector] = useState({});

    useEffect(() => {
        const criteria = { ReportName: 'DefaultSpecimenReport' };
        Post('config/getreport', criteria, configDataRetrieved, errorWhenRetrievingData);
    }, [props])
    
    const nameChangeHandler = (key, value) => {
        setReportName(value);
    };

    const selectorChangeHandler = (key, value) => {
        setPrintSelector(value);
    };

    const configDataRetrieved = (data) => {
        setReportConfig(data);
        const parameters = [{ Key: 'id', Value: props.id }];
        const criteria = { Name: "SpecimenRecordReport", Parameters: parameters};
        Post('query/filteredget', criteria, reportDataRetrieved, errorWhenRetrievingData);
    }

    const reportDataRetrieved = (data) => {
        setOriginalReportData(data);
        let formattedData = JSON.parse(data);
        FormatReportData(formattedData);
        var accessionNumber = formattedData.Standard.filter((f) => f.Key === "accessionnumber");
        setReportName(accessionNumber[0].Value + " - " + CurrentDate());
        setReportData(formattedData);
    }

    const errorWhenRetrievingData = (response) => {
        updateErrorStatus({visible: true, message: response.data});
    }
    
    const publishClickHandler = (print) => {
        if (reportConfig !== undefined && reportData !== undefined) {
            const event = { Event: 'specimenreport', Id: props.id, Name: reportName, Contents: originalReportData, Config: 'DefaultSpecimenReport', printed: print}
            PostEvent(event, () => reportPublishedSuccessfully(print), errorWhenRetrievingData );
        }
    };

    const reportPublishedSuccessfully = (print) => {
        if (print) {
            WriteAndDownloadReport(reportData, reportConfig, reportName, props.language);
            setSuccessStatus({visible: true, message: TranslateTag('@RepRepB@', props.language)});
        } else {
            setSuccessStatus({visible: true, message: TranslateTag('@RepRepA@', props.language)});
        }
        props.refresh("embeddedrefresh");
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }

    nameConfig.value = reportName;

    return (
        <div className="app-crafted-content">
            <div className='app-crafted-title'>{props.config.PageTitle}</div>
            <div className='app-crafted-headertext'>
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>

            <div className="app-formcolumn">
                <SingleLineField key="PublishName" config={nameConfig} changeHandler={nameChangeHandler}></SingleLineField>
                {/* <ReportFilter specimenid={props.id} language={props.language} config={props.config} changeHandler={selectorChangeHandler} value={printSelector}></ReportFilter> */}
            </div>

            <br></br>
            <div className="printpublish-buttons">
                    <CompoundButton primary onClick={() => publishClickHandler(false)} >
                        <div className="printpublish-button">
                            {publishIcon}
                            <br></br>
                            {TranslateTag("@RepPub@", props.language)}
                        </div>
                    </CompoundButton> 
                    <div className="printpublish-separator"></div>
                    <CompoundButton primary onClick={() => publishClickHandler(true)} >
                        <div className="printpublish-button">
                            {publishIcon}  {printIcon}
                            <br></br>
                            {TranslateTag("@RepPriA@", props.language)}
                        </div>
                    </CompoundButton>   
            </div>

            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
            <SuccessMessage visible={successStatus.visible} message={successStatus.message}></SuccessMessage>

        </div>
    )
};

export default PrintPublish;